/* ============================================================
   PRODUCTS (products.js) — GENERATED FROM THE LIVE STORE
   Source: https://obedpadilla.com/collections/merch/products.json?limit=250
   Regenerated by tools/sync_store.py — real titles, prices,
   sizes, availability, official photos, and REAL variant IDs
   (the cart checkout builds an obedpadilla.com cart link).
   Do not hand-edit; rerun the sync instead.
   ============================================================ */

const STORE_URL = 'https://obedpadilla.com';

const PRODUCTS = {
  "b-d-white-tee": {
    "id": "b-d-white-tee",
    "shopifyId": 10510615937316,
    "handle": "b-d-white-tee",
    "name": "B&D White Tee",
    "price": 40.0,
    "currency": "USD",
    "description": "",
    "accent": "#c8821a",
    "badge": "NEW",
    "image": "https://cdn.shopify.com/s/files/1/0870/1542/4292/files/26OBP003_C.png?v=1781646769",
    "photos": [
      "https://cdn.shopify.com/s/files/1/0870/1542/4292/files/26OBP003_C.png?v=1781646769"
    ],
    "url": "https://obedpadilla.com/products/b-d-white-tee",
    "variants": [
      {
        "id": 55027719700772,
        "label": "S",
        "available": true
      },
      {
        "id": 55027719733540,
        "label": "M",
        "available": true
      },
      {
        "id": 55027719766308,
        "label": "L",
        "available": true
      },
      {
        "id": 55027719799076,
        "label": "XL",
        "available": true
      },
      {
        "id": 55027719831844,
        "label": "2XL",
        "available": true
      },
      {
        "id": 55027719864612,
        "label": "3XL",
        "available": true
      }
    ]
  },
  "b-d-brown-tee": {
    "id": "b-d-brown-tee",
    "shopifyId": 10510614495524,
    "handle": "b-d-brown-tee",
    "name": "B&D Brown Tee",
    "price": 40.0,
    "currency": "USD",
    "description": "",
    "accent": "#8e1f14",
    "badge": "NEW",
    "image": "https://cdn.shopify.com/s/files/1/0870/1542/4292/files/26OBP003_B.png?v=1781646833",
    "photos": [
      "https://cdn.shopify.com/s/files/1/0870/1542/4292/files/26OBP003_B.png?v=1781646833"
    ],
    "url": "https://obedpadilla.com/products/b-d-brown-tee",
    "variants": [
      {
        "id": 55027584991524,
        "label": "S",
        "available": true
      },
      {
        "id": 55027585024292,
        "label": "M",
        "available": true
      },
      {
        "id": 55027585057060,
        "label": "L",
        "available": true
      },
      {
        "id": 55027585089828,
        "label": "XL",
        "available": true
      },
      {
        "id": 55027585122596,
        "label": "2XL",
        "available": true
      },
      {
        "id": 55027585155364,
        "label": "3XL",
        "available": true
      }
    ]
  },
  "b-d-black-tee": {
    "id": "b-d-black-tee",
    "shopifyId": 10510613053732,
    "handle": "b-d-black-tee",
    "name": "B&D Black Tee",
    "price": 40.0,
    "currency": "USD",
    "description": "",
    "accent": "#b3541e",
    "badge": "NEW",
    "image": "https://cdn.shopify.com/s/files/1/0870/1542/4292/files/26OBP003_A.png?v=1781646960",
    "photos": [
      "https://cdn.shopify.com/s/files/1/0870/1542/4292/files/26OBP003_A.png?v=1781646960"
    ],
    "url": "https://obedpadilla.com/products/b-d-black-tee",
    "variants": [
      {
        "id": 55027453034788,
        "label": "S",
        "available": true
      },
      {
        "id": 55027453067556,
        "label": "M",
        "available": true
      },
      {
        "id": 55027453100324,
        "label": "L",
        "available": true
      },
      {
        "id": 55027453133092,
        "label": "XL",
        "available": true
      },
      {
        "id": 55027453165860,
        "label": "2XL",
        "available": true
      },
      {
        "id": 55027453198628,
        "label": "3XL",
        "available": true
      }
    ]
  },
  "rodeo-hoodie": {
    "id": "rodeo-hoodie",
    "shopifyId": 10460502622500,
    "handle": "rodeo-hoodie",
    "name": "Rodeo Hoodie",
    "price": 65.0,
    "currency": "USD",
    "description": "",
    "accent": "#7a5233",
    "badge": null,
    "image": "https://cdn.shopify.com/s/files/1/0870/1542/4292/files/26OBP002_B.png?v=1777924405",
    "photos": [
      "https://cdn.shopify.com/s/files/1/0870/1542/4292/files/26OBP002_B.png?v=1777924405"
    ],
    "url": "https://obedpadilla.com/products/rodeo-hoodie",
    "variants": [
      {
        "id": 53687261954340,
        "label": "S",
        "available": true
      },
      {
        "id": 53687261987108,
        "label": "M",
        "available": true
      },
      {
        "id": 53687262019876,
        "label": "L",
        "available": true
      },
      {
        "id": 53687262052644,
        "label": "XL",
        "available": true
      },
      {
        "id": 53687262085412,
        "label": "2XL",
        "available": true
      },
      {
        "id": 53687262118180,
        "label": "3XL",
        "available": true
      }
    ]
  },
  "rodeo-tee": {
    "id": "rodeo-tee",
    "shopifyId": 10460501901604,
    "handle": "rodeo-tee",
    "name": "Rodeo Tee",
    "price": 40.0,
    "currency": "USD",
    "description": "",
    "accent": "#a44a2c",
    "badge": null,
    "image": "https://cdn.shopify.com/s/files/1/0870/1542/4292/files/26OBP002_A.png?v=1777924271",
    "photos": [
      "https://cdn.shopify.com/s/files/1/0870/1542/4292/files/26OBP002_A.png?v=1777924271"
    ],
    "url": "https://obedpadilla.com/products/rodeo-tee",
    "variants": [
      {
        "id": 53687260283172,
        "label": "S",
        "available": true
      },
      {
        "id": 53687260315940,
        "label": "M",
        "available": true
      },
      {
        "id": 53687260348708,
        "label": "L",
        "available": true
      },
      {
        "id": 53687260381476,
        "label": "XL",
        "available": true
      },
      {
        "id": 53687260414244,
        "label": "2XL",
        "available": true
      },
      {
        "id": 53687260447012,
        "label": "3XL",
        "available": true
      }
    ]
  },
  "sabor-bandana": {
    "id": "sabor-bandana",
    "shopifyId": 10315640537380,
    "handle": "sabor-bandana",
    "name": "Sabor Bandana",
    "price": 15.0,
    "currency": "USD",
    "description": "",
    "accent": "#9c7a1e",
    "badge": null,
    "image": "https://cdn.shopify.com/s/files/1/0870/1542/4292/files/25OBP002_A.png?v=1767988754",
    "photos": [
      "https://cdn.shopify.com/s/files/1/0870/1542/4292/files/25OBP002_A.png?v=1767988754"
    ],
    "url": "https://obedpadilla.com/products/sabor-bandana",
    "variants": [
      {
        "id": 51618221850916,
        "label": "Default Title",
        "available": true
      }
    ]
  },
  "im-the-son-of-immigrants-tee-black-white": {
    "id": "im-the-son-of-immigrants-tee-black-white",
    "shopifyId": 10246998622500,
    "handle": "im-the-son-of-immigrants-tee-black-white",
    "name": "I'm the Son of Immigrants Tee - Black/White",
    "price": 40.0,
    "currency": "USD",
    "description": "",
    "accent": "#c8821a",
    "badge": null,
    "image": "https://cdn.shopify.com/s/files/1/0870/1542/4292/files/25OBP003_A.png?v=1763086091",
    "photos": [
      "https://cdn.shopify.com/s/files/1/0870/1542/4292/files/25OBP003_A.png?v=1763086091"
    ],
    "url": "https://obedpadilla.com/products/im-the-son-of-immigrants-tee-black-white",
    "variants": [
      {
        "id": 51311502885156,
        "label": "S",
        "available": true
      },
      {
        "id": 51311502917924,
        "label": "M",
        "available": true
      },
      {
        "id": 51311502950692,
        "label": "L",
        "available": true
      },
      {
        "id": 51311502983460,
        "label": "XL",
        "available": true
      },
      {
        "id": 51311503016228,
        "label": "2XL",
        "available": true
      },
      {
        "id": 51311503048996,
        "label": "3XL",
        "available": true
      }
    ]
  },
  "im-the-son-of-immigrants-tee-white-blue": {
    "id": "im-the-son-of-immigrants-tee-white-blue",
    "shopifyId": 10246992888100,
    "handle": "im-the-son-of-immigrants-tee-white-blue",
    "name": "I'm the Son of Immigrants Tee - White/Blue",
    "price": 40.0,
    "currency": "USD",
    "description": "",
    "accent": "#8e1f14",
    "badge": null,
    "image": "https://cdn.shopify.com/s/files/1/0870/1542/4292/files/25OBP003_C.png?v=1763085795",
    "photos": [
      "https://cdn.shopify.com/s/files/1/0870/1542/4292/files/25OBP003_C.png?v=1763085795"
    ],
    "url": "https://obedpadilla.com/products/im-the-son-of-immigrants-tee-white-blue",
    "variants": [
      {
        "id": 51311490400548,
        "label": "S",
        "available": true
      },
      {
        "id": 51311490433316,
        "label": "M",
        "available": true
      },
      {
        "id": 51311490466084,
        "label": "L",
        "available": true
      },
      {
        "id": 51311490498852,
        "label": "XL",
        "available": true
      },
      {
        "id": 51311490531620,
        "label": "2XL",
        "available": true
      },
      {
        "id": 51311490564388,
        "label": "3XL",
        "available": true
      }
    ]
  },
  "im-the-son-of-immigrants-tee-white": {
    "id": "im-the-son-of-immigrants-tee-white",
    "shopifyId": 10246992363812,
    "handle": "im-the-son-of-immigrants-tee-white",
    "name": "I'm the Son of Immigrants Tee - White/Black",
    "price": 40.0,
    "currency": "USD",
    "description": "",
    "accent": "#b3541e",
    "badge": null,
    "image": "https://cdn.shopify.com/s/files/1/0870/1542/4292/files/25OBP003_D.png?v=1763085610",
    "photos": [
      "https://cdn.shopify.com/s/files/1/0870/1542/4292/files/25OBP003_D.png?v=1763085610"
    ],
    "url": "https://obedpadilla.com/products/im-the-son-of-immigrants-tee-white",
    "variants": [
      {
        "id": 51311485255972,
        "label": "S",
        "available": true
      },
      {
        "id": 51311485288740,
        "label": "M",
        "available": true
      },
      {
        "id": 51311485321508,
        "label": "L",
        "available": true
      },
      {
        "id": 51311485354276,
        "label": "XL",
        "available": true
      },
      {
        "id": 51311485387044,
        "label": "2XL",
        "available": true
      },
      {
        "id": 51311485419812,
        "label": "3XL",
        "available": true
      }
    ]
  },
  "im-the-son-of-immigrants-hoodie": {
    "id": "im-the-son-of-immigrants-hoodie",
    "shopifyId": 10246991872292,
    "handle": "im-the-son-of-immigrants-hoodie",
    "name": "I'm the Son of Immigrants Hoodie",
    "price": 65.0,
    "currency": "USD",
    "description": "",
    "accent": "#7a5233",
    "badge": null,
    "image": "https://cdn.shopify.com/s/files/1/0870/1542/4292/files/25OBP003_F.png?v=1763085415",
    "photos": [
      "https://cdn.shopify.com/s/files/1/0870/1542/4292/files/25OBP003_F.png?v=1763085415"
    ],
    "url": "https://obedpadilla.com/products/im-the-son-of-immigrants-hoodie",
    "variants": [
      {
        "id": 51311481684260,
        "label": "S",
        "available": true
      },
      {
        "id": 51311481717028,
        "label": "M",
        "available": true
      },
      {
        "id": 51311481749796,
        "label": "L",
        "available": true
      },
      {
        "id": 51311481782564,
        "label": "XL",
        "available": true
      },
      {
        "id": 51311481815332,
        "label": "2XL",
        "available": true
      },
      {
        "id": 51311481848100,
        "label": "3XL",
        "available": true
      }
    ]
  }
};
